import { __rest } from "tslib";
import React from 'react';
import { connectField, filterDOMProps, nothing } from 'uniforms';

var Error = function Error(_a) {
  var children = _a.children,
      error = _a.error,
      errorMessage = _a.errorMessage,
      props = __rest(_a, ["children", "error", "errorMessage"]);

  return !error ? nothing : React.createElement("div", Object.assign({}, filterDOMProps(props)), children ? children : React.createElement("div", {
    style: {
      margin: '3px'
    }
  }, errorMessage));
};

Error.defaultProps = {
  style: {
    backgroundColor: 'rgba(255, 85, 0, 0.2)',
    border: '1px solid rgb(255, 85, 0)',
    borderRadius: '7px',
    margin: '20px 0px',
    padding: '10px'
  }
};
export default connectField(Error, {
  initialValue: false
});